import React, { useRef } from 'react';
import Logo from '../assets/images/ishtari-logo.png';

function RedirectModal({ setClicked }) {
  const showRef = useRef(false);

  const handleRedirect = () => {
    const currentUrl = window.location.href;
    let dynamicPath = '';

    if (currentUrl.includes('localhost:3002/')) {
      dynamicPath = currentUrl.split('localhost:3002/')[1];
    } else if (currentUrl.includes('ishtari.com.gh/')) {
      dynamicPath = currentUrl.split('ishtari.com.gh/')[1];
    }
console.log(dynamicPath);

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const openUrl = `www.ishtari.com.gh://open/${dynamicPath}`;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    showRef.current = true;
    renderButtons();

    if (isAndroid) {
      const intentUrl = `intent://www.ishtari.com.gh/${dynamicPath}#Intent;scheme=https;package=com.smartdevision.app.ishtari;end`;
      window.location = intentUrl;
    } else if (isIOS) {
      window.location = openUrl;
    }
  };

  const openStore = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    showRef.current = false;
    renderButtons();

    if (isAndroid) {
      window.location = "https://play.google.com/store/apps/details?id=com.smartdevision.app.ishtari&pcampaignid=web_share";
    } else if (isIOS) {
      window.open("https://apps.apple.com/app/1248110122");
    }
  };

  const renderButtons = () => {
    const openBtn = document.getElementById("openBtn");
    if (showRef.current) {
      openBtn.onclick = openStore;
    } else {
      openBtn.onclick = handleRedirect;
    }
  };

  return (
    <div className="fixed inset-x-0 mt-3 bottom-0 w-full justify-between lg:flex items-center bg-white p-3 shadow-lg z-50 lg:justify-center">
      <div className="flex">
        <img src={Logo} className="w-10 h-10 rounded-lg" />
        <div className="text-left mt-2">
          <span className="text-sm font-semibold ml-2">Ishtari app</span>
        </div>
        <div className="ml-auto">
          <button id="openBtn" onClick={handleRedirect} className="px-3 py-1 rounded-full bg-dbase text-white font-semibold">
            Open
          </button>
        </div>
      </div>
      <div className="ml-6">
        <button className="text-sm ml-32" onClick={() => setClicked(true)}>
          Not now, continue in browser
        </button>
      </div>
    </div>
  );
}

export default RedirectModal;
